<footer class="footer" style="z-index: 99;">
    <div class="container-fluid">
        <span class="copyright" style="text-align: center;">
            <div class="d-flex justify-content-center gap-2">
                <div class="flex-shrink-0">
                    <div>© MyFile Inc. {{year}}</div>
                </div>
                <div>
                    |
                </div>
                <div class="flex-shrink-0" style="display: inline-flex;">
                    <i class="bx bxs-lock-alt" style="margin: 2px;"></i>
                    <div i18n="@@Footer_text_EndToEnd">End-to-End Encrypted</div>
                </div>
                <div *ngIf="loginType != undefined">
                    |
                </div>
                <div *ngIf="loginType == loginTypeEnum.User" class="flex-shrink-0" style="display: inline-flex;">
                    <div routerLink={{clientLoginPath}} class="text-decoration-underline" style="cursor: pointer;"
                        i18n="@@">Client Sign In</div>
                </div>
                <div *ngIf="loginType == loginTypeEnum.Client" class="flex-shrink-0" style="display: inline-flex;">
                    <div routerLink={{userLoginPath}} class="text-decoration-underline" style="cursor: pointer;"
                        i18n="@@">Corporate Sign In</div>
                </div>
                <div *ngIf="version">
                    |
                </div>
                <div *ngIf="version" class="flex-shrink-0">
                    {{version}}
                </div>

                <div *ngIf="version" class="rounded" [ngStyle]=statusTextStyle(flag)>
                    <div *ngIf="flag else elseDev">Prod</div>
                    <ng-template #elseDev>
                        <span>Dev</span>
                    </ng-template>
                </div>

            </div>
        </span>
    </div>
    <!-- this is a quick fix for stripe color calls - cause they always render correctly - see SingleCheckoutComponentComponent -->
    <div style="display: none; height: 0px; width: 0px;">
        <div id="hiddenText">Text</div>
        <input id="hiddenInput" type="text" class="form-control">
    </div>
</footer>